@if (dataVisible$ | async) {
  <form [formGroup]="formGroup">
    <div class="row">
      <div class="col col-1">
        <p>Aftrekbare zorgkosten</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button (click)="this.showDialog()"
                             [disabled]="(formGroup.controls.aftrekbareZorgkosten.value ?? 0) === 0"
                             class="custom-input-150"
                             icon="eye"
                             type="secondary">Specificatie
        </snelstart-ui-button>
      </div>
      <div class="col-2">
        <snelstart-ui-number-form-control
          [decimals]="0"
          align="right"
          class="custom-input-150"
          formControlName="aftrekbareZorgkosten"
          id="aftrekbareZorgkosten"
          placeholder="-"
          prefix="€"
        ></snelstart-ui-number-form-control>
      </div>
      <div class="col-2"></div>
    </div>
  </form>

  <snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="lg" size="lg" title="Specificatie zorgkosten">
    <snelstart-ui-dialog-body>
      <form [formGroup]="formGroup">
        <div>
          @if ((formGroup.controls.behandelKosten.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Behandelkosten</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="behandelKosten"
                  id="behandelKosten"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.medicijnKosten.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Medicijnkosten</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="medicijnKosten"
                  id="medicijnKosten"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.hulpmiddelen.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Hulpmiddelen</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="hulpmiddelen"
                  id="hulpmiddelen"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.aftrekbaarExtraGezinshulp.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Kosten extra gezinshulp</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="aftrekbaarExtraGezinshulp"
                  id="aftrekbaarExtraGezinshulp"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.reiskostenEigenZorg.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Reiskosten eigen zorg</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="reiskostenEigenZorg"
                  id="reiskostenEigenZorg"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.reiskostenGezinslid.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Reiskosten ziek gezinslid</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="reiskostenGezinslid"
                  id="reiskostenGezinslid"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.kledingEnBeddengoed.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Aftrek extra kosten kleding en beddengoed</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="kledingEnBeddengoed"
                  id="kledingEnBeddengoed"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.dieetkosten.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Dieetkosten</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="dieetkosten"
                  id="dieetkosten"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.totaalZorgkostenVoorVerhoging.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Totale zorgkosten</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="totaalZorgkostenVoorVerhoging"
                  id="totaalZorgkostenVoorVerhoging"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.verhogingZorgkosten.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Bij: Verhoging</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="verhogingZorgkosten"
                  id="verhogingZorgkosten"
                  prefix="€"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
          @if ((formGroup.controls.drempelZorgkosten.value ?? 0) > 0) {
            <div class="row">
              <div class="col col-1">
                <p>Af: Drempel</p>
              </div>
              <div class="col-2">
                <snelstart-ui-number-form-control
                  [decimals]="0"
                  align="right"
                  class="custom-input-150"
                  formControlName="drempelZorgkosten"
                  id="drempelZorgkosten"
                  prefix="€ -"
                ></snelstart-ui-number-form-control>
              </div>
              <div class="col-2"></div>
            </div>
          }
        </div>
      </form>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
      <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
      <snelstart-ui-button icon="check" id="save" type="primary">
        Akkoord
      </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
  </snelstart-ui-dialog-definition>
}
